const anchor = (value: string) => `/${value}/`;

export const nswContractExchangeDocuSignAnchors = {
  sellerInitial: (index: number) =>
    anchor(`NSWCESELLERINITH${index.toString().padStart(6, '0')}`),
  buyerInitial: (index: number) =>
    anchor(`NSWCEBUYERSINITH${index.toString().padStart(6, '0')}`),
} as const;
